import React from 'react'
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { statusTransitionServiceTranslation } from '../../../utils'
import AddStatusForm from '../AddStatusForm'

/**
 * What a status says beyond its name: the code it arrived with, and whatever was written with it.
 *
 * `CustomReason` is a code that means "free text", so on its own it explains nothing at all. The
 * comment beside it is the whole message — a lock reported broken read as "Deviation - CustomReason"
 * and the words "LUCKA SÖNDER" were in the parcel and on no screen.
 */
const statusDetail = (data) => {
  const said = [data?.code, data?.comment].filter(Boolean).join(' · ')
  return said ? ` - ${said}` : ''
}

// The registry shows this to everyone: the table is for any viewer, and AddStatusForm carries
// its own guards — it renders nothing for someone who may not add a status.
export default function Statuses({ parcel, onChanged }) {
  const { t } = useTranslation('parcels')

  return (
    <Stack spacing={2}>
      {/* no heading of its own: the box around this part is titled boxes.status,
          which in German is the same word again */}
      <TableContainer sx={{ maxHeight: 500, maxWidth: 800, mx: 'auto' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{t('timeCreated')}</TableCell>
              <TableCell>{t('status')}</TableCell>
              <TableCell>System</TableCell>
              <TableCell>{t('user')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(parcel.statuses || []).map((sts) => (
              <TableRow key={JSON.stringify(sts)}>
                <TableCell>{window.niceDate2(sts.created)}</TableCell>
                <TableCell>
                  {t(`statuses.${sts.name}`)}
                  {statusDetail(sts.data)}
                </TableCell>
                <TableCell>
                  {statusTransitionServiceTranslation(sts.service)}
                </TableCell>
                <TableCell>
                  {!sts.service?.match(/^retool/) ? sts.serviceUser : ''}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <AddStatusForm parcel={parcel} onChanged={onChanged} />
    </Stack>
  )
}
